import styled from 'styled-components'; 
import {color, space, layout, flexbox, borderRadius, boxShadow} from 'styled-system';

export const Box = styled('div')(color, space, layout, flexbox, borderRadius, boxShadow);